import consumer from "./consumer"

/**
 * Subscribes to the UserCreationChannel for a given UID.
 * When a passcode is received, redirects the browser to the login page with the passcode.
 * @param {string} uid - The unique identifier for the user creation session
 * @param {Function} onConnected - Optional callback to execute when connection is confirmed
 * @returns {Object} The ActionCable subscription
 */
export default function subscribeToUserCreation(uid, onConnected = null) {
  return consumer.subscriptions.create(
    { channel: "UserCreationChannel", uid },
    {
      /**
       * Called when the subscription is confirmed by the server.
       * Executes the onConnected callback if provided.
       */
      connected() {
        console.log('ActionCable connection confirmed for UID:', uid);
        if (onConnected && typeof onConnected === 'function') {
          onConnected();
        }
      },

      /**
       * Called when a broadcast is received from the server.
       * If a passcode is present, redirect to login with the passcode as a query param.
       * @param {Object} data - The broadcast data
       */
      received(data) {
        if (data.passcode) {
          // Redirect to login with the passcode for auto-login or verification
          window.location.href = "/login?passcode=" + encodeURIComponent(data.passcode);
        }
      }
    }
  );
}
